<template>
  <nav class="navbar navbar-expand-lg navbar-light bg-white shadow-sm fixed-top">
    <div class="container">
      <router-link class="navbar-brand fw-bold" to="/">
        <img src="@/assets/logo.png" :alt="$t('appName')" class="navbar-logo">
        <span class="brand-name">{{ $t('appName') }}</span>
      </router-link>
      <button 
        class="navbar-toggler" 
        type="button" 
        data-bs-toggle="collapse" 
        data-bs-target="#navbarNav"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav ms-auto">
          <li class="nav-item">
            <router-link class="nav-link" to="/">{{ $t('nav.home') }}</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/privacy">{{ $t('nav.privacy') }}</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/support">{{ $t('nav.support') }}</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" to="/contact">{{ $t('nav.contact') }}</router-link>
          </li>
          <li class="nav-item">
            <button class="btn btn-link nav-link" @click="toggleLanguage">
              <i class="bi bi-translate"></i> {{ currentLang === 'zh' ? 'EN' : '中文' }}
            </button>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'NavBar',
  computed: {
    currentLang() {
      return this.$i18n.locale
    }
  },
  methods: {
    toggleLanguage() {
      const newLang = this.$i18n.locale === 'zh' ? 'en' : 'zh'
      this.$i18n.locale = newLang
      localStorage.setItem('locale', newLang)
    }
  }
}
</script>

<style scoped>
.navbar {
  padding: 0;
  min-height: 72px;
  transition: all 0.3s ease;
}

.navbar .container {
  padding-top: 0;
  padding-bottom: 0;
}

.navbar-brand {
  font-size: 20px;
  line-height: 1.2;
  font-weight: 600;
  color: var(--color-text-primary) !important;
  transition: opacity 0.2s ease;
  padding: 16px 0;
  display: flex;
  align-items: center;
  gap: 12px;
}

.navbar-brand:hover {
  opacity: 0.8;
}

.navbar-logo {
  height: 34px;
  width: 34px;
  object-fit: contain;
}

.brand-name {
  font-size: 20px;
  font-weight: 600;
}

.nav-link {
  font-size: 15px;
  font-weight: 400;
  color: var(--color-text-primary) !important;
  transition: opacity 0.2s ease;
  position: relative;
  padding: 24px 18px !important;
  letter-spacing: 0.01em;
}

.nav-link:hover {
  opacity: 0.8;
}

.nav-link.router-link-active {
  opacity: 1;
}

.btn-link {
  text-decoration: none;
  padding: 24px 18px !important;
  font-size: 15px;
  color: var(--color-text-primary) !important;
}

.btn-link:hover {
  opacity: 0.8;
}

.navbar-toggler {
  border: none;
  padding: 8px;
}

.navbar-toggler:focus {
  box-shadow: none;
}

@media (max-width: 992px) {
  .navbar {
    min-height: 64px;
  }
  
  .navbar-brand {
    font-size: 18px;
  }
  
  .navbar-logo {
    height: 30px;
    width: 30px;
  }
  
  .brand-name {
    font-size: 18px;
  }
  
  .nav-link {
    font-size: 16px;
    padding: 12px 0 !important;
  }
  
  .btn-link {
    font-size: 16px;
    padding: 12px 0 !important;
  }
}
</style>
